<article class="publish-preview-card">
  <header class="publish-preview-card__header">
    <div class="publish-preview-card__identity">
      <span
        class="publish-preview-card__icon-wrap"
        [ngClass]="account.iconCssClass"
      >
        <span
          [inlineSVG]="account.icon"
          class="publish-preview-card__icon"
          aria-hidden="true"
        ></span>
      </span>
      <span class="publish-preview-card__name">{{ account.name }}</span>
    </div>
    <span class="publish-preview-card__aspect">{{ aspectRatio }}</span>
  </header>

  <div class="publish-preview-card__body">
    <div class="publish-preview-card__cover-col">
      <div
        class="publish-preview-card__cover"
        [style.aspect-ratio]="coverAspectRatioCss"
      >
        <img
          *ngIf="coverUrl"
          class="publish-preview-card__cover-img"
          [src]="coverUrl"
          alt=""
        />
        <div
          *ngIf="!coverUrl"
          class="publish-preview-card__cover-placeholder"
          aria-hidden="true"
        >
          <img
            class="publish-preview-card__cover-placeholder-icon"
            src="/assets/icons/video-icon.svg"
            alt=""
          />
        </div>
      </div>
    </div>

    <div class="publish-preview-card__meta">
      <p class="publish-preview-card__title">{{ title }}</p>
      <p
        *ngFor="let line of settingsLines"
        class="publish-preview-card__setting-line"
      >
        {{ line }}
      </p>
    </div>
  </div>
</article>
